module.exports = __webpack_public_path__ + "static/inspospotr-footerBanner-min-b7284e52da74551669e33ff5dc3dcdbe.jpg";